module.exports = __webpack_public_path__ + "img/V-63-ER-1500-MI.8e0a039f.png";